import { PAGES } from './routes';

import actions from '../actions';

export const IMAGES_PER_PAGE = 25;

export const BULK_DOWNLOAD_LIMIT = 25;

export const THUMBNAIL_SIZE = 178;

export const ORDER_BY = {
  LISTINGS_CONNECTED: 'connected_listing_count',
  PHOTO_EDITED_DATE: 'created_at',
};

export const ORDER_LABEL = {
  [ORDER_BY.LISTINGS_CONNECTED]: 'Listings connected',
  [ORDER_BY.PHOTO_EDITED_DATE]: 'Photo edited date',
};

export const PAGE_TO_DATA_SOURCE_MAP = {
  [PAGES.STUDIO_PHOTO]: 'photo',
  [PAGES.STUDIO_VIDEO]: 'video',
  [PAGES.STUDIO]: 'photo', // TODO: delete with FEATURE_FLAG_VIDEO_STUDIO
};

export const PAGE_TO_ACTION_MAP = {
  [PAGES.STUDIO_PHOTO]: actions.studio.photo,
  [PAGES.STUDIO_VIDEO]: actions.studio.video,
  [PAGES.STUDIO]: actions.studio.photo, // TODO: delete with FEATURE_FLAG_VIDEO_STUDIO
};

